// {
//     name: '',
//     type: '',
//     path: '',
//     license: '',
//     author: '',
//     url: ''
// }

export default [
    {
        name: 'studioHDR',
        type: 'exr',
        path: '/hdri/ocan_sky.exr',
        license: '',
        author: '',
        url: ''
    },
    {
        name: 'nightHDR',
        type: 'exr',
        path: '/hdri/dark_night.exr',
        license: '',
        author: '',
        url: ''
    },
    {
        name: 'FishModel1',
        type: 'gltf',
        path: '/models/glb/fish-v1.glb',
        license: '',
        author: 'Kilian Rizzo',
        url: ''
    },
    {
        name: 'Dauphins',
        type: 'gltf',
        path: '/models/glb/Dauphins_v13.glb',
        license: '',
        author: 'Kilian Rizzo',
        url: ''
    },
    {
        name: 'Dauphin',
        type: 'gltf',
        path: '/models/glb/Dauphin-anim_v4.glb',
        license: '',
        author: 'Kilian Rizzo',
        url: ''
    },
    {
        name: 'Couloir',
        type: 'gltf',
        path: '/models/glb/Couloir_v9.glb',
        license: '',
        author: 'Kilian Rizzo',
        url: ''
    },
    {
        name: 'Aquaturtle',
        type: 'gltf',
        path: '/models/glb/Tortues_bas_V9.glb',
        license: '',
        author: 'Kilian Rizzo',
        url: ''
    },
    {
        name: 'AquaturtleHaut',
        type: 'gltf',
        path: '/models/glb/Tortues_haut_V10.glb',
        license: '',
        author: 'Kilian Rizzo',
        url: ''
    },
    {
        name: 'Tortue',
        type: 'gltf',
        path: '/models/glb/Tortue_V3.glb',
        license: '',
        author: 'Kilian Rizzo',
        url: ''
    },
    {
        name: 'Elevator',
        type: 'gltf',
        path: '/models/glb/Assenceur_v5.glb',
        license: '',
        author: 'Kilian Rizzo',
        url: ''
    },
    {
        name: 'BoatScene',
        type: 'gltf',
        path: '/models/glb/Bateau_v8.glb',
        license: '',
        author: 'Kilian Rizzo',
        url: ''
    },
    {
        name: 'captain_igloo_hacked',
        type: 'texture',
        path: '/textures/paintings/Capitaine_igloo_Hacked.jpeg'
    },
    {
        name: 'chalutier_hacked',
        type: 'texture',
        path: '/textures/paintings/Chalutier_Hacked.jpeg'
    },
    {
        name: 'dauphin_hacked',
        type: 'texture',
        path: '/textures/paintings/Dauphin_Hacked.jpeg'
    },
    {
        name: 'pirogue_hacked',
        type: 'texture',
        path: '/textures/paintings/Pirogue_Hacked.jpeg'
    },
    {
        name: 'tortue_hacked',
        type: 'texture',
        path: '/textures/paintings/Tortue_Hacked.jpeg'
    }
]